(() => {
  if (window.__uzProductCardSwatchesReady) return;
  window.__uzProductCardSwatchesReady = true;

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-product-card-swatch]');
    if (!swatch) return;

    const card = swatch.closest('[data-product-card-root]');
    if (!card) return;

    card.querySelectorAll('[data-product-card-swatch]').forEach((button) => {
      button.setAttribute('aria-pressed', button === swatch ? 'true' : 'false');
    });

    const image = card.querySelector('[data-product-card-image]');
    const mediaUrl = swatch.dataset.mediaUrl;
    if (!image || !mediaUrl) return;

    image.setAttribute('src', mediaUrl);
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
  });
})();
